import './LoadingScreen.css';

import classnames from 'classnames';
import { type FC, memo, type ReactNode } from 'react';

interface LoadingScreenProps {
  loadingText?: string;
  visible?: boolean;
  fullScreen?: boolean;
  spinner?: ReactNode;
}

const LoadingScreen: FC<LoadingScreenProps> = ({
  visible = false,
  loadingText,
  fullScreen = false,
  spinner,
}) => {
  return (
    visible && (
      <div
        className={classnames('flex gap-3 justify-center items-center bg-base-300 text-2xl', {
          'h-screen w-screen fixed top-0 left-0': fullScreen,
          'h-full w-full absolute top-0 left-0': !fullScreen,
          'z-9999': visible,
        })}
      >
        <div className="loading-screen-color-cycle flex gap-2">
          {spinner ? spinner : <span className="loading loading-spinner loading-lg" />}
        </div>
        {loadingText && <span>{loadingText}</span>}
      </div>
    )
  );
};

export default memo(LoadingScreen);
